import type { AppLanguage } from '../types';
import { en, type MessageKey } from './en';
import { he } from './he';

export type { MessageKey };

const catalogs: Record<AppLanguage, Record<MessageKey, string>> = {
  en,
  he,
};

export function getCatalog(language: AppLanguage): Record<MessageKey, string> {
  return catalogs[language] ?? catalogs.en;
}
